// Handles firing DOMReady events on scripts loaded asynchronously

const DOMReady = (callback) => {
  document.readyState === 'interactive' || document.readyState === 'complete'
    ? callback()
    : document.addEventListener('DOMContentLoaded', callback);
};

export default DOMReady;
